import { getMessaging, getToken } from 'firebase/messaging';
import { app } from '../config/firebase';

export async function getFCMToken(): Promise<string | null> {
  try {
    if (!('Notification' in window)) {
      console.error('This browser does not support desktop notifications');
      return null;
    }

    console.log('Checking notification permission:', Notification.permission);
    let permission = Notification.permission;

    if (permission === 'denied') {
      console.error('Notification permission was denied');
      return null;
    }

    if (permission === 'default') {
      console.log('Requesting notification permission...');
      permission = await Notification.requestPermission();
      console.log('Permission request result:', permission);
      if (permission !== 'granted') {
        console.error('Notification permission not granted');
        return null;
      }
    }

    const messaging = getMessaging(app);
    const vapidKey = import.meta.env.VITE_FCM_VAPID_KEY;

    if (!vapidKey) {
      console.error('FCM VAPID key not configured');
      return null;
    }

    console.log('Getting service worker registration...');
    const swRegistration = await navigator.serviceWorker.getRegistration();

    if (!swRegistration) {
      console.error('No service worker registration found');
      return null;
    }

    console.log('Requesting FCM token...');
    const token = await getToken(messaging, {
      vapidKey,
      serviceWorkerRegistration: swRegistration
    });

    if (!token) {
      console.error('Failed to obtain FCM token');
      return null;
    }

    console.log('FCM Token obtained successfully: ', token);
    return token;
  } catch (error) {
    console.error('Error in getFCMToken:', error);
    return null;
  }
}
